export default __webpack_public_path__ + "static/media/A-bank.3fe07abd.webp";